<template>
  <span
    class="badge bg-purple"
    :class="computedClass">
    <i class="fa fa-truck"/>
    Dropship Cart
  </span>
</template>

<script setup>
  import { computed } from 'vue';
  const props = defineProps(['classString'])

  // Computed
  const computedClass = computed(()=>{
    let classString
    switch(props.classString){
      case 'wide':
        classString = 'w-100'
        break;
      case 'inline':
        classString = 'd-inline-block'
        break;
    }
    return classString
  })
</script>